import { getBasePath } from '../../config/env';
import { AzdoLookupApi, Configuration } from '.';

const basePath = getBasePath() ?? '';

export const azdoLookupApi = new AzdoLookupApi(new Configuration({ basePath }));
